import { Fragment } from 'react';
import { ModularComparePageFragment } from '@/graphql';

import { notEmpty } from '@/lib/typescript-helpers';
import MasterTemplate from '@/templates/MasterTemplate';
import AlternatingFeatures from '@/components/_rebrand/craft/flex/AlternatingFeatures';
import { AlternatingFeaturesData } from '@/components/_rebrand/craft/flex/AlternatingFeatures/AlternatingFeatures.types';
import CompetitiveTable from '@/components/_rebrand/craft/product/CompetitiveTable';
import ThreeBenefits from '@/components/_rebrand/craft/product/ThreeBenefits';
import FAQ from '@/components/_rebrand/craft/product/FAQ';
import Bumper from '@/components/_rebrand/craft/flex/Bumper';
import ProductValidation from '@/components/_rebrand/craft/flex/ProductValidation';
import WhyFront from '@/components/_rebrand/craft/flex/WhyFront';
import FeatureExploration from '@/components/_rebrand/craft/flex/FeatureExploration';
import TabbedFeatures from '@/components/_rebrand/craft/flex/TabbedFeatures';
import AllFeatures from '@/components/_rebrand/craft/product/AllFeatures';
import FlexPageHero from '@/components/_rebrand/craft/flex/FlexPageHero';
import { FlexPageHeroData } from '@/components/_rebrand/craft/flex/FlexPageHero/FlexPageHero.types';
import BlockDivider from '@/components/_rebrand/craft/flex/BlockDivider';
import PaddedDivider from '@/components/_rebrand/craft/flex/PaddedDivider';

type ComparisonModularPageProps = {
  entry: ModularComparePageFragment;
};

const ComparisonModularPage: PageTemplate<ComparisonModularPageProps> = ({ entry }) => {
  if (!entry) {
    return null;
  }

  return (
    <Fragment>
      {entry.comparisonModules.filter(notEmpty).map((block) => {
        switch (block.__typename) {
          case 'comparisonModules_competitiveTable_BlockType':
            const entryData = { moduleProductCompetitiveTable: block, moduleProductTheme: Array({ color: 'pink' }) };

            return <CompetitiveTable entry={entryData} />;

          case 'comparisonModules_threexBenefits_BlockType':
            return <ThreeBenefits entry={block} />;

          case 'comparisonModules_faq_BlockType':
            return <FAQ entry={block} />;

          case 'comparisonModules_bumper_BlockType':
            return <Bumper entry={block} />;

          case 'comparisonModules_g2Validation_BlockType':
            return <ProductValidation entry={block} />;

          case 'comparisonModules_whyFront_BlockType':
            return <WhyFront entry={block} />;

          case 'comparisonModules_featureExploration_BlockType':
            return <FeatureExploration entry={block} />;

          case 'comparisonModules_tabbedFeatures_BlockType':
            return <TabbedFeatures entry={block} />;

          case 'comparisonModules_allFeatures_BlockType':
            return <AllFeatures entry={block} />;

          case 'comparisonModules_pageHero_BlockType':
            return <FlexPageHero entry={block as unknown as FlexPageHeroData} />;

          case 'comparisonModules_blockDivider_BlockType':
            return <BlockDivider entry={block} />;

          case 'comparisonModules_solidPaddedDivider_BlockType':
            return <PaddedDivider entry={block} />;

          case 'comparisonModules_alternatingFeatureBlocks_BlockType':
            return <AlternatingFeatures entry={block as unknown as AlternatingFeaturesData} />;

          default:
            return null;
        }
      })}
    </Fragment>
  );
};

ComparisonModularPage.template = MasterTemplate;

export default ComparisonModularPage;
